<template>
  <div id="stock-info" class="stock-info mobile-content">
    <div class="header-container">
      <div class="title-container">
          <span>Información del ticker</span>
      </div>
      <div class="close-btn-container">
          <span class="material-icons-outlined" @click="_closeComponent()">close</span>
      </div>
    </div>
    <div class="info-ticker-box">
      <p class="text-info-ticker">Ticker: <span class="text-bold">{{_g_SelectedTicker.ticker}}</span></p>
    </div>

    <div class="card-info" id="card-info-id">
      <div class="card-info-box">
        <p class="text-info-grey">Divisa: <span class="text-info-dark text-bold">{{_g_SelectedTicker.divisa}}</span></p>
        
        <p class="text-info-grey">Valor de la divisa: <span class="text-info-dark">{{ _g_SelectedTicker.cotitzacio_divisa }} {{ _g_SelectedTicker.divisa }}</span></p>

        <p class="text-info-grey">Índice: <span class="text-info-dark">{{ _g_SelectedTicker.index_valor }}</span></p>
      
        <p class="text-info-grey">Sector: <span class="text-info-dark">{{ _g_SelectedTicker.sector }}</span></p>
  
        <p class="text-info-grey">Industria: <span class="text-info-dark">{{ _g_SelectedTicker.industria }}</span></p>
    
        <p class="text-info-grey">País: <span class="text-info-dark">{{ _g_SelectedTicker.country }}</span></p>

        <hr />
      </div>
      <div class="card-info-box">
        <p class="text-info-grey">Valor: <span class="text-info-dark">{{ _g_SelectedTicker.valor_actual }} {{_selectDivisa(_g_SelectedTicker.divisa)}}</span></p>

        <p class="text-info-grey">Entrada: <span class="text-info-dark">{{ _g_SelectedTicker.real_entry.toFixed(2) }} {{_selectDivisa(_g_SelectedTicker.divisa)}}</span></p>

        <p class="text-info-grey">Stop: <span class="text-info-dark">{{ _g_SelectedTicker.out_price.toFixed(2) }} {{_selectDivisa(_g_SelectedTicker.divisa)}}</span></p>
        
        <p class="text-info-grey">Cantidad: <span class="text-info-dark">{{ _g_SelectedTicker.amount.toFixed(2) }} {{_selectDivisa(_g_SelectedTicker.divisa)}}</span></p>
  
        <p class="text-info-grey">Distancia de entrada: <span class="text-info-dark">{{ _g_SelectedTicker.entry_distance.toFixed(2) }} %</span></p>
      
        <p class="text-info-grey">Acciones: <span class="text-info-dark">{{ _g_SelectedTicker.instrument_number }}</span></p>

        <hr />
      </div>
      <div class="card-info-box">
        <p class="text-info-grey">Tipo de entrada: <span class="text-info-dark">{{ _g_SelectedTicker.entry_type_name }}</span></p>
        
        <p class="text-info-grey">Número de onda: <span class="text-info-dark">{{ _g_SelectedTicker.num_ona_actual }}</span></p>
        
        <p class="text-info-grey">Rentabilidad: <span class="text-info-dark">{{ _g_SelectedTicker.tae_lt.toFixed(2) }} %</span></p>
      
        <p class="text-info-grey">Soporte: <span class="text-info-dark">{{ _g_SelectedTicker.soport }} {{_selectDivisa(_g_SelectedTicker.divisa)}}</span></p>
        
        <p class="text-info-grey">Fecha de soporte: <span class="text-info-dark">{{ _dataFormat(_g_SelectedTicker.data_soport) }}</span></p>
      
        <p class="text-info-grey">1ª Fecha: <span class="text-info-dark">{{ _dataFormat(_g_SelectedTicker.fecha_primera_barra) }}</span></p>
    
        <hr />
      </div>
      <div class="card-info-box">
        <p class="text-info-grey">Dividendos: <span class="text-info-dark">{{ _g_SelectedTicker.avg_dividends }}</span></p>
    
        <p class="text-info-grey">CFD: <span class="text-info-dark">{{ _g_SelectedTicker.cfd_margin }} %</span></p>
        
        <p class="text-info-grey">Margen CFD: <span class="text-info-dark">Alcista y Bajista habilitado</span></p>
      
        <p class="text-info-grey">Fecha de análisis: <span class="text-info-dark">{{ _dataFormat2(_g_SelectedTicker.data_analisi) }}</span></p>
    
        <p class="text-info-grey">Inversión/Riesgo: <span class="text-info-dark">{{ _g_SelectedTicker.risk_reward }}</span></p>

        <p class="text-info-grey">Compatibilidad: <span class="text-info-dark">{{ (_g_SelectedTicker.user_platinum_compatibility * 100).toFixed(2)}} %</span></p>
        
        <hr />
      </div>
      <div class="card-info-box">
        <p v-if="info_rol == 'Platino'" class="text-is-fullscreen text-info-grey">Brain: <span class="text-info-dark">{{Math.round(_g_SelectedTicker.platinum_compatibility * 100)}}</span></p>
        <p v-else class="text-is-fullscreen text-info-grey">Brain: <span class="text-info-dark">No disponible</span></p>
      </div>
    </div>
  </div>
</template>



<script>
import { mapGetters } from "vuex";
import APICaller from "@/shared/mixins/APICaller.js";

export default {
  mixins:[APICaller],
  name: 'Info',
  components: {
  },
  data() {
    return {
      id_header: 'stock-info',
      title_header: 'Información del ticker',
      user_id: "",
      info_rol: "",
    };
  },
  mounted() {
   
  },
  created: function() {
    this._getUID();
    this._getUserInfo();
  },
  computed: {
      ...mapGetters(['_g_SelectedTicker', '_g_User']),
  },
  methods: {
    _selectDivisa : function(valor){
      if (valor == 'EUR'){
        return '€';
      }
      else if (valor == 'EURUSD') {
        return '$';
      }
      else {
        return valor;
      }
    },
    _dataFormat: function(value){
      value= value.split("-");
      let new_value = value[2] + "-" + value[1] + "-" + value[0];
      return new_value;
    },
    _dataFormat2: function(value){
      let year = value.substring(0,4);
      let month = value.substring(4,6);
      let day = value.substring(6,8);
      let new_value = day + "-" + month + "-" + year;
      return new_value;
    },

    _getUID: function(){
      this.user_id = this._g_User.uid;
    },

    _getUserInfo: function(){
      this.info_rol = this._g_User.user_features.platinum_score.info;
    },

    _closeComponent: function() {
      this.$emit("_closeComponentInfoMobile");
    },

  },
}
</script>


<style lang="scss" scoped>

  @import "@/styles/basics/globals.scss";
  
  
  p {
    margin: 0;
    padding: 0;
    line-height: 24px;
    color: #7D8294;
  }

  span {
    color: black;
  }

  a {
    text-decoration: none;
    color: #35add8;
  }

  hr {
    border: 1px solid rgba(0, 0, 0, 0.12);
    margin: 22px 5%;
  }

  .info-ticker-box {
     width: 100%;
     display: flex;
     justify-content: center;
  }
  .text-info-ticker {
    text-align: center;
    background-color: #F3F4F7;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin-bottom: 24px;
    width: 130px;
    padding: 7px 20px;
    color: black;
  }

  .text-bold {
    font-weight: bold;
  }

  .text-info-grey {
    font-size: 14px;
    line-height: 26px;
    letter-spacing: 0.25px;
    color: #7D8294;
  }

  .text-info-dark {
    color: #000000;
  }

  .card-info {
    margin: 0 35px;
    display: flex;
    flex-wrap: wrap;
  }

  .card-info-box {
    width: 100%;
  }
  
  .is-fullscreen {
    width: 30%;
    margin: 0 10%
  }

  #text-is-fullscreen {
    margin-bottom: 50px;
  }

  .mobile-content {
    margin-top: 15px;
    height: 460px;
    min-height: 420px;
    overflow-y: scroll;
  }

  .header-container{
    display: flex;
    justify-content: center;
    padding: 10px 0px 30px 0px !important;
  }

  .title-container{
    margin-left: 30px;
    font-size: 20px;
    font-weight: 600;
  }

  .close-btn-container{
    margin-left: auto;
    order: 2;
    margin-right: 10px;
  }

</style>